module.exports = __webpack_public_path__ + "img/Ticker-X-White.a6be32a3.svg";